// localStorage に boolean フラグを '1'/'0' で永続化する小ヘルパー。
// プライベートモード等で利用不可な環境では false / no-op に倒す。

export function loadFlag(key) {
  if (!key) return false;
  try {
    return localStorage.getItem(key) === '1';
  } catch (_e) {
    return false;
  }
}

export function saveFlag(key, value) {
  if (!key) return;
  try {
    localStorage.setItem(key, value ? '1' : '0');
  } catch (_e) {
    // localStorage 利用不可（プライベートモード等）は無視
  }
}
